module.exports = __webpack_public_path__ + "img/email_diamant-rose.86052f42.jpg";